<template>
  <div :class="{ 'has-error': validacao.$error }" class="form-group">
    <label v-if="exibeLabel">
      {{ label }} <sup>{{ labelSup }}</sup>
    </label>
    <select
      :id="id"
      :data-test-id="`select-${id}`"
      :name="id"
      :disabled="somenteLeitura"
      :value="valor"
      class="form-control"
      @change="atualizar($event.target)"
    >
      <option v-if="mostrarTodos" value=""> Todos </option>
      <option v-if="mostrarSelecione" value=""> Selecione </option>
      <option
        v-for="e in especialidades"
        :key="e.id"
        :selected="e.nome === valorInterno"
        :value="usarIdComoValue ? e._id : e.nome"
      >
        {{ e.nome }}
      </option>
    </select>
    <div v-if="validacao.$dirty" class="help-block">
      <slot name="mensagensValidacao" />
    </div>
  </div>
</template>

<script>
import { campoMixin } from '@/mixins/CampoMixin'
import EspecialidadeServico from '@/servicos/EspecialidadeServico'

const especialidadeServico = new EspecialidadeServico()

export default {
  name: 'SelecionarEspecialidade',
  mixins: [campoMixin],
  props: {
    label: {
      type: String,
      default: 'Especialidade',
    },
    id: {
      type: String,
      default: 'especialidade',
    },
    mostrarTodos: {
      type: Boolean,
      default: true,
    },
    mostrarSelecione: {
      type: Boolean,
      default: false,
    },
    usarIdComoValue: {
      type: Boolean,
      default: false,
    },
    valorPadrao: {
      type: Boolean,
      default: false,
    },
    remover: {
      type: Array,
      default: () => [],
    },
    orderBy: {
      type: String,
      default: 'nome',
    },
  },
  data() {
    return {
      especialidades: [],
    }
  },
  created() {
    especialidadeServico
      .recuperarTodos({ ativo: true, orderBy: this.orderBy })
      .then((result) => {
        this.especialidades = result.especialidades

        if (this.valorPadrao) {
          this.atualizar({ value: this.especialidades[0].nome })
        }

        if (this.remover.length) {
          this.remover.forEach((nome) => {
            const index = this.especialidades.findIndex((e) => e.nome === nome)
            if (~index) this.especialidades.splice(index, 1)
          })
        }

        this.$emit('pronto', this.especialidades)
      })
  },
}
</script>
